import { Navigate, useLoaderData } from 'react-router-dom'
import StepThreeForgetPassword from '../StepThree'

const StepOneForgetPassword = () => {
  const { token } = useLoaderData()

  // Jika terdapat token di URL (?token=...), tetap layani reset password via StepThree
  if (token) {
    return <StepThreeForgetPassword token={token} />
  }

  // Jika tanpa token, alihkan langsung ke alur login resmi (/login)
  return <Navigate to="/login" replace />
}

export default StepOneForgetPassword

export const loader = (props) => {
  const { request } = props
  let token =
    request.url?.split('?')[1]?.split('&')[0]?.split('=')[1] ?? undefined
  return { token }
}
